import { render, staticRenderFns } from "./component-games-list-slider.vue?vue&type=template&id=7dee627e&scoped=true"
import script from "./component-games-list-slider.vue?vue&type=script&lang=js"
export * from "./component-games-list-slider.vue?vue&type=script&lang=js"
import style0 from "./component-games-list-slider.vue?vue&type=style&index=0&id=7dee627e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dee627e",
  null
  
)

export default component.exports